import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';

import { TextField, Tag, TextContainer, Stack } from '@shopify/polaris';
import { capitalize } from 'lodash';

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  // tags: PropTypes.array.isRequired,

  onRemove: PropTypes.func.isRequired,

  errors: PropTypes.object,
};

const defaultProps = {
  type: "text"
}


// Need to find a way to chane input and display tags with comma separated.
class TagsInput extends PureComponent{

  renderTags = () => {
    return this.props.value.split(",").map((option) => {
      let tagLabel = '';
      // tagLabel = option.replace('_', ' ');
      tagLabel = capitalize(option);
      return (
        <Tag key={'option' + option} 
          onRemove={() => this.props.onRemove(option)}>
          {tagLabel}
        </Tag>
      );
    });
  };

  render(){
    let { name, label, handleChange, value, errors, onRemove, tags, ...props } = this.props;
    let splitted = this.props.value.split(",");
    let  inputValue  = splitted[splitted.length - 1];

    // console.log("Tag pure component");
    return(
      <div>
        <TextField
          id={name}
          name={name}
          label={label || capitalize(name)}
      
          onChange={handleChange}
          value={ value }
          error={errors && errors[name]}
      
          {...props}
        />
        {/* <Stack>{this.renderTags()}</Stack> */}

      </div>
    )
  }
}


TagsInput.propTypes = propTypes;
TagsInput.defaultProps = defaultProps;


export default TagsInput;

// {
//   tags.map((tag, index) =>
//     <Tag key={index}
//       onRemove={() => onRemove(option)}>
//       {tag}
//     </Tag>
//   )
// }